(() => {
  const configEl = document.getElementById('cart-promos-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch {
    return;
  }
  if (!config.length) return;

  class CartPromos {
    constructor(config) {
      this.config = config;
      this.processing = false;
    }

    init() {
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._subscribe();
      } else {
        // pubsub.js loads deferred — wait for it
        const check = setInterval(() => {
          if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            clearInterval(check);
            this._subscribe();
          }
        }, 50);
      }
      this.evaluate();
    }

    _subscribe() {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === 'cart-promos') return;
        this.evaluate();
      });
    }

    async evaluate() {
      if (this.processing) return;
      this.processing = true;
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        const adds = [];
        const removes = [];

        for (const promo of this.config) {
          if (promo.tipo === 'coleccion_regalo') {
            this._evalColeccionRegalo(promo, cart, adds, removes);
          } else if (promo.tipo === 'mismo_producto') {
            this._evalMismoProducto(promo, cart, adds, removes);
          }
        }

        let changed = false;

        if (removes.length) {
          await this._removeItems(removes);
          changed = true;
        }
        if (adds.length) {
          await this._addItems(adds);
          changed = true;
        }

        if (changed && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-promos' });
        }
      } catch (err) {
        console.error('[CartPromos]', err);
      } finally {
        this.processing = false;
      }
    }

    // Promo 2: sum qty of all trigger-collection products in cart
    // >= cantidad_trigger → add 1 random gift from regalo collection
    _evalColeccionRegalo(promo, cart, adds, removes) {
      const triggerIds = new Set(promo.trigger_ids.map(String));
      const giftIds = promo.regalo_ids;

      let triggerQty = 0;
      for (const item of cart.items) {
        if (item.properties?._regalo === 'true') continue;
        if (triggerIds.has(String(item.product_id))) triggerQty += item.quantity;
      }

      const existingGifts = cart.items.filter(
        (i) => i.properties?._regalo === 'true' && i.properties?._promo === 'coleccion_regalo'
      );

      if (triggerQty >= promo.cantidad_trigger) {
        if (existingGifts.length === 0 && giftIds.length > 0) {
          const giftId = giftIds[Math.floor(Math.random() * giftIds.length)];
          adds.push({
            id: giftId,
            quantity: 1,
            properties: { _regalo: 'true', _promo: 'coleccion_regalo' },
          });
        }
      } else {
        for (const gift of existingGifts) removes.push(gift.key);
      }
    }

    // Promo 3: per cart line — if a trigger product reaches cantidad_trigger units,
    // add 1 free unit of that exact same variant
    _evalMismoProducto(promo, cart, adds, removes) {
      const triggerIds = new Set(promo.trigger_ids.map(String));

      for (const item of cart.items) {
        if (item.properties?._regalo === 'true') continue;
        if (!triggerIds.has(String(item.product_id))) continue;

        const promoKey = `mismo_producto_${item.variant_id}`;
        const existingGift = cart.items.find(
          (i) => i.properties?._regalo === 'true' && i.properties?._promo === promoKey
        );

        if (item.quantity >= promo.cantidad_trigger) {
          if (!existingGift) {
            adds.push({
              id: item.variant_id,
              quantity: 1,
              properties: {
                _regalo: 'true',
                _promo: promoKey,
                _regalo_para: item.title,
              },
            });
          }
        } else {
          if (existingGift) removes.push(existingGift.key);
        }
      }
    }

    async _removeItems(keys) {
      const updates = {};
      for (const key of keys) updates[key] = 0;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }

    async _addItems(items) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
    }
  }

  const promos = new CartPromos(config);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => promos.init());
  } else {
    promos.init();
  }
})();
